<div class="wrapper">

    <app-sidenav/>

    <app-topbar/>

    <div class="content-page">

        <router-outlet/>

        <footer class="footer">
            <app-footer class="w-100"/>
        </footer>
    </div>

</div>
